import React from 'react';
import Card from '@teetsh/app/src/components/Card';
import getAvatar from './getAvatar';
import styled from '@emotion/styled';
import tw from 'twin.macro';

interface Props {
  type: 'boy' | 'girl';
  onChange: (v: string) => void;
}

const AvatarIcon = styled.div`
  ${tw`h-16 w-16`}
`;

export default function List(props: Props) {
  const { type, onChange } = props;

  const maxPictureSize = type === 'boy' ? 23 : 27;
  return (
    <div tw="flex flex-wrap">
      {[...Array(maxPictureSize - 1).keys()].map(i => {
        const ii = i + 1 < 10 ? `0${i + 1}` : i + 1;
        const fileName = `${type === 'boy' ? 'boys' : 'girls'}/0${ii}-${type}`;
        const avatar = getAvatar(fileName);

        return (
          <div key={i} tw="relative">
            <Card
              onClick={() => onChange(fileName)}
              interactive
              css={[
                tw`rounded bg-neutral-moderate p-2! flex justify-center items-center mr-2 mb-2 h-16 w-16`,
              ]}
            >
              {typeof avatar === 'string' ? (
                <img src={avatar} alt="Star" tw="h-full" />
              ) : (
                <AvatarIcon as={avatar} />
              )}
            </Card>
          </div>
        );
      })}
    </div>
  );
}
